'use client'
import React, { useState } from 'react'
import { withLayout } from '../../shared/Styles.js'
import { Picture, Text } from '../../components/index.js'
import { cn } from '../../helpers/index.js'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Mousewheel, FreeMode } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import type { GiftBoxDataType, GiftBoxType } from './types.js'

const GiftItem = ({ item }: { item: GiftBoxDataType }) => (
  <div className="rounded-card laptop:p-[20px] tablet:h-full tablet:px-3 laptop:px-4 lg-desktop:p-8 flex h-[120px] flex-col items-center justify-center overflow-hidden bg-[#EAEAEC] px-4 py-[12px]">
    <div className="min-h-0 flex-1">
      {item?.img?.url && (
        <Picture
          className="laptop:block desktop:w-[116px] lg-desktop:w-[146px] hidden aspect-[194/194] w-[88px]"
          imgClassName=""
          source={item?.img?.url}
          alt={item?.img?.alt || ''}
        />
      )}
      {item?.mobileImg?.url && (
        <Picture
          className="laptop:hidden block aspect-[120/120] h-full"
          imgClassName=""
          source={item?.mobileImg?.url}
          alt={item?.mobileImg?.alt || ''}
        />
      )}
    </div>
    <Text
      html={item?.title}
      className="laptop:text-[18px] line-clamp-2 shrink-0 text-center text-[14px] font-bold leading-[1.4]"
    />
  </div>
)

const GiftBox = (props: GiftBoxType) => {
  const { data, className } = props
  const { list } = data

  return (
    <div className="w-full">
      {/* Mobile: Grid 静态布局 2 列 (<768px) */}
      <div className={cn('tablet:hidden grid grid-cols-2 gap-3', className)}>
        {list.map((item, index) => (
          <GiftItem key={`mobile-${index}`} item={item} />
        ))}
      </div>

      {/* Tablet+: Swiper 轮播 (≥768px)
          - 768px~1024px (tablet~laptop): 4 个可见
          - ≥1025px (laptop+): 4.2 个可见
          - ≥1440px (desktop+): 6 个可见
      */}
      <div className={cn('tablet:block hidden', className)}>
        <div className="relative">
          <Swiper
            modules={[Pagination, Mousewheel, FreeMode]}
            freeMode={true}
            spaceBetween={16}
            slidesPerView="auto"
            pagination={{
              clickable: true,
              el: '.gift-box-pagination',
            }}
            mousewheel={{
              forceToAxis: true,
            }}
            breakpoints={{
              768: {
                spaceBetween: 12,
                slidesPerView: 4,
              },
              1025: {
                spaceBetween: 16,
                slidesPerView: 4,
              },
              1440: {
                spaceBetween: 16,
                slidesPerView: 6,
              },
            }}
            className="laptop:!overflow-visible [&_.swiper-slide]:!h-auto [&_.swiper-wrapper]:items-stretch"
          >
            {list.map((item, index) => (
              <SwiperSlide key={`carousel-${index}`} className="!h-full items-stretch">
                <GiftItem item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
          {/* 自定义 Pagination - 仅 tablet 显示 */}
          <div className="gift-box-pagination laptop:hidden mt-3 flex justify-center [&_.swiper-pagination-bullet-active]:!bg-[#080A0F] [&_.swiper-pagination-bullet]:size-2 [&_.swiper-pagination-bullet]:rounded-full [&_.swiper-pagination-bullet]:bg-[#767880] [&_.swiper-pagination-bullet]:opacity-100" />
        </div>
      </div>
    </div>
  )
}

export default withLayout(GiftBox)
